export default {
    apiKey: "AIzaSyAuQfjgmgvYG2-rlT2E6Y3zEPaoR92O_q8",
    authDomain: "timesheet-tracker-eae58.firebaseapp.com",
    databaseURL: "https://timesheet-tracker-eae58-default-rtdb.firebaseio.com",
    projectId: "timesheet-tracker-eae58",
    storageBucket: "timesheet-tracker-eae58.appspot.com",
    messagingSenderId: "23036730295",
    appId: "1:23036730295:web:ef6f2854f4cf611b942632",
    measurementId: "G-ZR75K7MFZV"
}


// WEBPACK FOOTER //
// ./src/config/firebaseConfig.js